class Shipping {
  static cartValueExceedsFreeShippingThreshold(cartValue, minimumCartValue) {
    return cartValue >= minimumCartValue;
  }

  static cartValueRemainingForFreeShipping(cartValue, minimumCartValue) {
    return Shipping.cartValueExceedsFreeShippingThreshold(cartValue, minimumCartValue)
      ? 0
      : minimumCartValue - cartValue;
  }

  static cartPercentageUntilFreeShipping(cartValue, minimumCartValue) {
    return Shipping.cartValueExceedsFreeShippingThreshold(cartValue, minimumCartValue)
      ? 100
      : Math.floor((cartValue / minimumCartValue) * 100);
  }
}

export default Shipping;
